module.exports = __webpack_public_path__ + "static/media/Info.28b607d5.svg";